import axios from './config/config-viva';

const defaultRoute = 'planos/';

export default {
    list: () => axios.get(`${defaultRoute}`),
    findOne:(id) => axios.get(`${defaultRoute}one/${id}`),
    create: (plano) => axios.post(defaultRoute, plano),
    update: (id, plano) => axios.put(defaultRoute+id, plano),
    remove: (id) => axios.delete(defaultRoute+id)
}